<div class="agent-chat-container" [class.open]="isOpen" *ngIf="hasAccess">
  <!-- Floating Toggle Button (Always accessible at bottom-right of ERP when closed) -->
  <button class="chat-toggle-btn" *ngIf="!isOpen && hasAccess" (click)="toggleChat()">
    <span>✨ AI Agent</span>
  </button>

  <!-- Fullscreen Chat Window -->
  <div class="chat-fullscreen-overlay" *ngIf="isOpen">
    <div class="chat-window" #chatWindow>
      <!-- Chat Header -->
      <div class="chat-header">
        <div class="header-content">
          <div class="agent-title-row">
            <span class="header-main-title">✨ KCEG AI Copilot</span>
            <span class="agent-badge">{{ selectedAgent.icon }} {{ selectedAgent.name }} &bull; {{ selectedAgent.badge }}</span>
          </div>
          <p class="header-subtitle">{{ currentPeriod ? 'Period: ' + currentPeriod : 'KCEG Operational & Financial Intelligence' }}</p>
        </div>
        <div class="header-actions">
          <button class="clear-chat-btn" (click)="clearChat()" title="Clear chat history">
            🗑️ Clear
          </button>
          <button class="close-window-btn" (click)="toggleChat()" title="Close chat window">
            ✕ Close
          </button>
        </div>
      </div>

    <!-- Agent Selection Hub / Cards View -->
    <div class="agent-picker-overlay" *ngIf="showAgentPicker">
      <div class="picker-header">
        <h4>Choose an AI Specialist</h4>
        <p>Select the specialized agent best suited for your inquiry</p>
      </div>

      <div class="agent-cards-grid">
        <div 
          *ngFor="let agent of agentOptions" 
          class="agent-card" 
          [class.active]="activeAgentId === agent.agentId"
          (click)="selectAgent(agent)">
          <div class="agent-card-top">
            <span class="card-icon">{{ agent.icon }}</span>
            <div class="card-title-group">
              <span class="card-name">{{ agent.name }}</span>
              <span class="card-badge">{{ agent.badge }}</span>
            </div>
          </div>
          <p class="card-desc">{{ agent.description }}</p>
          <div class="card-prompts-preview">
            <span class="preview-label">Suggested:</span>
            <span class="preview-chip">{{ agent.starterPrompts[0] }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Chat Messages View -->
    <div class="chat-messages" *ngIf="!showAgentPicker">
      <div *ngFor="let msg of messages; let i = index" class="message-wrapper" [ngClass]="msg.sender" [attr.id]="'msg-' + i">
        <div [ngClass]="['message', msg.sender]" [innerHTML]="msg.html || msg.text"></div>
        <button *ngIf="msg.sender === 'agent'" class="copy-btn" (click)="copyMessage(msg)" title="Copy formatted text">
          {{ msg.copied ? '✅ Copied!' : '📋 Copy' }}
        </button>
      </div>

      <!-- Quick Starter Prompt Chips & Agent Selection (Rendered when starting conversation or cleared) -->
      <div class="starter-chips-container" *ngIf="messages.length <= 1 && !isLoading">
        <div class="agent-switch-section">
          <div class="chips-title">🎯 Select AI Specialist:</div>
          <div class="agent-selector-pills">
            <button 
              *ngFor="let agent of agentOptions" 
              type="button"
              class="agent-select-pill" 
              [class.active]="activeAgentId === agent.agentId"
              (click)="selectAgent(agent)">
              <span class="pill-icon">{{ agent.icon }}</span>
              <span class="pill-name">{{ agent.name }}</span>
            </button>
          </div>
        </div>

        <!-- Optional Device Selector in Starter Section (Shown only for Kiosk App Support) -->
        <div class="device-switch-section" *ngIf="isKioskAgentSelected">
          <div class="chips-title">🖥️ Target Photobooth Device (Optional):</div>
          <div class="device-picker-row">
            <div class="device-filter-dropdown-container">
              <button type="button" class="device-dropdown-trigger-btn large" (click)="toggleStarterDeviceDropdown($event)">
                <span class="device-selected-text">{{ selectedDeviceDisplayLabel }}</span>
                <span class="dropdown-arrow">▼</span>
              </button>

              <div class="device-dropdown-menu" *ngIf="showStarterDeviceDropdownMenu" (click)="$event.stopPropagation()">
                <div class="device-search-header">
                  <input 
                    type="text" 
                    class="device-search-input" 
                    [(ngModel)]="starterDeviceSearchText" 
                    placeholder="🔍 Filter devices by name / ID / store..."
                    autofocus
                  />
                </div>
                <div class="device-dropdown-list">
                  <div 
                    class="device-option-item" 
                    [class.active]="!selectedDeviceId" 
                    (click)="selectDevice('')">
                    <span>None / All Devices</span>
                  </div>
                  <div 
                    *ngFor="let dev of getFilteredStarterDevices()" 
                    class="device-option-item" 
                    [class.active]="selectedDeviceId === dev.deviceId" 
                    (click)="selectDevice(dev.deviceId)">
                    <span>🖥️ {{ dev.displayLabel }}</span>
                  </div>
                  <div *ngIf="getFilteredStarterDevices().length === 0" class="device-option-empty">
                    No devices match filter.
                  </div>
                </div>
              </div>
            </div>

            <button *ngIf="selectedDeviceId" type="button" class="btn-clear-device" (click)="selectDevice('')">
              ✕ Clear Device
            </button>
          </div>
        </div>

        <div class="chips-title">💡 Suggested Inquiries for {{ selectedAgent.name }}{{ selectedDeviceId ? ' on ' + selectedDeviceId : '' }}:</div>
        <div class="chips-list">
          <button 
            *ngFor="let chip of getFormattedStarterPrompts()" 
            type="button"
            class="starter-chip" 
            (click)="sendStarterPrompt(chip)">
            {{ chip }}
          </button>
        </div>
      </div>

      <!-- Typing Indicator -->
      <div *ngIf="isLoading" class="message-wrapper agent">
        <div class="message agent loading">
          <div class="typing-indicator"><span></span><span></span><span></span></div>
        </div>
        <button class="copy-btn" (click)="stopThinking()" title="Stop generating">
          ⏹ Stop
        </button>
      </div>
    </div>

    <!-- Footer: Input Bar & Agent Selection Dropdown Below Input -->
    <div class="chat-footer-bar">
      <div class="chat-input-area">
        <input 
          #chatInput
          type="text" 
          [(ngModel)]="userInput" 
          (keyup.enter)="sendMessage()"
          [placeholder]="inputPlaceholder"
          [disabled]="isLoading"
        />
        <button (click)="sendMessage()" [disabled]="isLoading || !userInput.trim()">
          Send
        </button>
      </div>

      <!-- Agent & Device Selection Bar Below Input Textbox -->
      <div class="chat-agent-bar">
        <div class="agent-bar-left">
          <div class="agent-dropdown-wrapper">
            <label class="agent-dropdown-label" for="agentSelect">
              <span class="label-text">Active Specialist:</span>
            </label>
            <div class="agent-select-custom">
              <select 
                id="agentSelect" 
                class="agent-dropdown-select" 
                [ngModel]="activeAgentId" 
                (ngModelChange)="onAgentSelectChange($event)">
                <option *ngFor="let agent of agentOptions" [value]="agent.agentId">
                  {{ agent.icon }} {{ agent.name }} &mdash; {{ agent.badge }}
                </option>
              </select>
            </div>
          </div>

          <!-- Device Dropdown (Shown only when Kiosk Specialist is active) with Filter Searchbox -->
          <div class="agent-dropdown-wrapper device-dropdown-wrapper" *ngIf="isKioskAgentSelected">
            <label class="agent-dropdown-label">
              <span class="label-text">Device (Optional):</span>
            </label>

            <div class="device-filter-dropdown-container">
              <button type="button" class="device-dropdown-trigger-btn" (click)="toggleDeviceDropdown($event)">
                <span class="device-selected-text">{{ selectedDeviceDisplayLabel }}</span>
                <span class="dropdown-arrow">▼</span>
              </button>

              <div class="device-dropdown-menu footer-menu" *ngIf="showDeviceDropdownMenu" (click)="$event.stopPropagation()">
                <div class="device-search-header">
                  <input 
                    type="text" 
                    class="device-search-input" 
                    [(ngModel)]="deviceSearchText" 
                    placeholder="🔍 Filter devices by name / ID..."
                    autofocus
                  />
                </div>
                <div class="device-dropdown-list">
                  <div 
                    class="device-option-item" 
                    [class.active]="!selectedDeviceId" 
                    (click)="selectDevice('')">
                    <span>None / All Devices</span>
                  </div>
                  <div 
                    *ngFor="let dev of getFilteredDevices()" 
                    class="device-option-item" 
                    [class.active]="selectedDeviceId === dev.deviceId" 
                    (click)="selectDevice(dev.deviceId)">
                    <span>🖥️ {{ dev.displayLabel }}</span>
                  </div>
                  <div *ngIf="getFilteredDevices().length === 0" class="device-option-empty">
                    No devices match filter.
                  </div>
                </div>
              </div>
            </div>

            <button 
              *ngIf="selectedDeviceId" 
              type="button" 
              class="btn-clear-device-pill" 
              (click)="selectDevice('')" 
              title="Clear selected device">
              ✕
            </button>
          </div>
        </div>

        <div class="agent-bar-right">
          <button type="button" class="btn-view-all-agents" (click)="toggleAgentPicker()" [class.active]="showAgentPicker" title="View all AI specialist cards">
            {{ showAgentPicker ? '💬 Back to Chat' : '🎯 All Specialists' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>